import { Dispatch } from 'redux';
import {
    UPDATE_TOUR_STATUS_ERROR,
    UPDATE_TOUR_STATUS_SUCCESS,
    UpdateTourStatusErrorAction,
    UpdateTourStatusSuccessAction,
    UserLaneActionTypes,
} from '../types';
import { fetchUpdateTourStatus } from '../../../../services/UserLaneApi';

export function updateTourStatus(userLaneId: string): (dispatch: Dispatch<UserLaneActionTypes>) => void {
    return async (dispatch: Dispatch<UserLaneActionTypes>) => {
        try {
            await fetchUpdateTourStatus(userLaneId);
            dispatch(updateTourStatusSuccess(true));
        } catch (error) {
            dispatch(updateTourError(new Error(error)));
        }
    };
}

const updateTourStatusSuccess = (updated: boolean): UpdateTourStatusSuccessAction => ({
    type: UPDATE_TOUR_STATUS_SUCCESS,
    payload: {
        updated,
    },
});

const updateTourError = (error: Error): UpdateTourStatusErrorAction => ({
    type: UPDATE_TOUR_STATUS_ERROR,
    error,
});
